var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.user_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 mx-0 no-gutters" },
            [
              _c("back-button", {
                staticClass: "btnFilter_2 mr-2",
                attrs: { returnUrl: _vm.returnUrl },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "mx-auto" }),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _vm.User
            ? [
                _c("div", { staticClass: "title-label-blue w-200px pt-3" }, [
                  _vm._v(_vm._s(_vm.$t("administration.user_info"))),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "table" }, [
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { staticClass: "text-center w-50" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("administration.identifier")) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.User.Login) +
                            "\n              "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.User.Name
                      ? _c("tr", [
                          _c("th", { staticClass: "text-center w-50" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("administration.user_name")) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.User.Name) +
                                "\n              "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { staticClass: "text-center w-50" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("administration.active")) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center w-50" }, [
                        _vm.User.Active == 0
                          ? _c("i", {
                              staticClass:
                                "fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.User.Active == 2
                          ? _c("i", {
                              staticClass:
                                "fa-duotone fa-check btn btn-icon btn-icon-green p-0 min-h-auto",
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.User.Active == 1
                          ? _c("i", {
                              staticClass:
                                "fa-duotone fa-warning btn btn-icon btn-icon-orange p-0 min-h-auto",
                            })
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("hr", { staticClass: "mx-auto" }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "title-label-blue w-200px pt-3" }, [
                  _vm._v(_vm._s(_vm.$t("administration.user_auth"))),
                ]),
                _vm._v(" "),
                _vm.User.Rights && _vm.User.Rights.length
                  ? _c("table", { staticClass: "table table-striped" }, [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _c("th", { staticClass: "text-center w-50" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t("administration.company_name")
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center w-50" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("administration.profile")) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.User.Rights, function (right) {
                            return _c(
                              "tr",
                              {
                                key:
                                  right.IdAccount + "-" + right.IdRightProfile,
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "cursor text-center w-50",
                                    on: {
                                      click: function ($event) {
                                        return _vm.seeCompanyDetail(
                                          right.IdAccount
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(right.AccountName) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "cursor text-center w-50",
                                    on: {
                                      click: function ($event) {
                                        return _vm.seeRoleDetail(
                                          right.IdRightProfile,
                                          right.IdAccount
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.hasProfileTrad(
                                            right.RightsProfileName
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  : _c("b-col", { staticClass: "mt-3" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("administration.no_profile")) +
                          "\n      "
                      ),
                    ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "min-w-100 align-items-center" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "d-flex justify-content-end" },
                      [
                        [
                          _vm.canUserEdit
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "back-button btnFilter_2 mr-2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.activateEdit(_vm.User.IdUser)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-light fa-pencil",
                                  }),
                                  _vm._v(
                                    "  " +
                                      _vm._s(
                                        _vm.$t("administration.user_edit")
                                      ) +
                                      "\n    \t\t\t\t"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canUserDelete
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "back-button btnFilter_2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.activateDelete(_vm.User.IdUser)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "fa-light fa-trash",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("administration.user_delete")
                                        )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }